import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileResult } from '../../types/result';

interface Props {
  result: ProfileResult;
  onRestart: () => void;
}

const CtaButton: React.FC<Props> = ({ result, onRestart }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <a
        href={result.cta_url}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full bg-scaleo-orange hover:bg-opacity-90 text-white font-bold py-4 px-6 rounded-2xl text-center transition-all shadow-lg hover:shadow-xl hover:scale-[1.01]"
      >
        <span className="block">{t('result.cta')}</span>
        <span className="block text-xs font-normal text-orange-100 mt-1">
          {t('result.ctaSubtitle')}
        </span>
      </a>

      <button
        onClick={onRestart}
        className="w-full text-gray-400 hover:text-gray-600 text-sm font-medium py-2 transition-colors"
      >
        {t('result.restart')}
      </button>
    </div>
  );
};

export default CtaButton;
